
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.203 3.538c0-.374-.207-.719-.542-.903a1.092 1.092 0 00-1.074.013L7.172 8.731H1.067C.477 8.73 0 9.196 0 9.769v12.462c0 .573.478 1.038 1.067 1.038h6.105l10.415 6.083c.33.192.74.197 1.074.013.335-.184.541-.53.541-.903V3.538zm-10.669 6.82l8.535-4.985v21.254l-8.535-4.984V10.357zm-2.133.45H2.134v10.384H6.4V10.808z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M27.885 7.886a1.086 1.086 0 011.488.241l.064.087a13.107 13.107 0 010 15.572l-.064.087a1.086 1.086 0 01-1.488.241 1.02 1.02 0 01-.248-1.448l.064-.087a11.075 11.075 0 000-13.158l-.064-.087a1.02 1.02 0 01.248-1.448z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M25.424 12.309a1.085 1.085 0 00-1.48-.288c-.49.318-.622.963-.295 1.44l.043.062a4.367 4.367 0 010 4.954l-.043.063a1.021 1.021 0 00.296 1.44c.49.318 1.152.189 1.48-.288l.042-.063a6.398 6.398 0 000-7.258l-.043-.062z","fill":"currentColor"}})])
          )
        }
      }
    